import React, { useState } from "react";
import "../CSS/PostOpportunityModal.css";

const PostOpportunityModal = ({
  onClose,
  onOpportunityPosted
}) => {
  const [formData, setFormData] = useState({
    type: "",
    industry: "",
    description: "",
    job_title: "",

    duration: "",
    location: "",
    name: "",

    openings: "",
    contact: "",
    website: ""
  });

  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState("");

  const handleChange = e => {
    const { name, value } = e.target;

    setFormData(previous => ({
      ...previous,
      [name]: value
    }));
  };

  const handleSubmit = async e => {
    e.preventDefault();
    setError("");

    if (
      !formData.type ||
      !formData.industry ||
      !formData.description ||
      
      !formData.location ||
      !formData.name ||
      !formData.contact ||
      !formData.openings ||
      !formData.job_title
    ) {
      setError("Please fill in all opportunity details.");
      return;
    }

    try {
      setSubmitting(true);

      const response = await fetch(
        "https://advenwarecareerlink.com/acl/employer/post_job.php",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json"
          },
        
          body: JSON.stringify(formData)
        }
      );

      if (!response.ok) {
        throw new Error("Failed to post opportunity.");
      }

      const data = await response.json();

      const newOpportunity = data.opportunity || {
        ...formData,
        id: Date.now(),
        active: true,
        studentsAvailable: 0
      };

      if (onOpportunityPosted) {
        onOpportunityPosted(newOpportunity);
      }

      alert('posting was a success awaiting approval from the head office.')
      onClose();
    } catch (err) {
      console.error(err);
      setError(
        "Unable to post opportunity. Please try again."
      );
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="opportunity-modal-overlay">
      <div className="opportunity-modal">
        <div className="opportunity-modal-header">
          <div>
            <div className="opportunity-modal-label">
              EMPLOYER PORTAL
            </div>
            <h2>Post new opportunity</h2>
            <p>
              Provide the details of the opportunity.
            </p>
          </div>

          <button
            type="button"
            className="opportunity-modal-close"
            onClick={onClose}
            aria-label="Close"
          >
            ×
          </button>
        </div>

        {error && (
          <div className="opportunity-modal-error">
            <span>!</span>
            {error}
          </div>
        )}

        <form
          className="post-opportunity-form"
          onSubmit={handleSubmit}
        >
          <div className="form-group">
            <label>Organisation Name</label>
            <input
              type="text"
              name="name"
              placeholder="e.g. Safaricom"
              value={formData.name}
              onChange={handleChange}
            />
          </div>

          <div className="form-group">
            <label>Job Title</label>
            <input
              type="text"
              name="job_title"
              placeholder="e.g Accountant"
              value={formData.job_title}
              onChange={handleChange}
            />
          </div>

          <div className="form-group">
            <label>Type of Position</label>
            <select
              name="type"
              value={formData.type}
              onChange={handleChange}
            >
              <option value="">
                Select Postion type
              </option>
              <option value="Industrial Attachment">
                Industrial Attachment
              </option>
              <option value="Internship">
                Internship
              </option>
              <option value="Field Attachment">
                Field Attachment
              </option>
              <option value="Teaching Practice">
                Teaching Practice
              </option>
              <option value="Work Experience">
                Work Experience
              </option>
            </select>
          </div>

          <div className="form-group">
            <label>Industry</label>
            <input
              type="text"
              name="industry"
              placeholder="e.g. Information Technology"
              value={formData.industry}
              onChange={handleChange}
            />
          </div>

          <div className="form-group">
            <label>Number of openings</label>
            <input
              type="text"
              name="openings"
              placeholder="e.g. 4"
              value={formData.openings}
              onChange={handleChange}
            />
          </div>

          <div className="form-group">
            <label>Organisation Contact</label>
            <input
              type="text"
              name="contact"
              placeholder="e.g 07XXXXXXXX"
              value={formData.contact}
              onChange={handleChange}
            />
          </div>

           <div className="form-group">
            <label>Organisation website (optional)</label>
            <input
              type="text"
              name="website"
              placeholder="e.g www.advenwarecareelink.com"
              value={formData.website}
              onChange={handleChange}
            />
          </div>

          <div className="form-group full-width">
            <label>Work description</label>
            <textarea
              name="description"
              placeholder="Describe the attachment opportunity, duties and requirements..."
              value={formData.description}
              onChange={handleChange}
              rows="5"
            />
          </div>

          <div className="form-group">
            <label>Job, Intership or attachment duration (optional)</label>
            <select
              name="duration"
              value={formData.duration}
              onChange={handleChange}
            >
              <option value="">
                Select duration
              </option>
              <option value="1 Month">1 Month</option>
              <option value="2 Months">2 Months</option>
              <option value="3 Months">3 Months</option>
              <option value="4 Months">4 Months</option>
              <option value="5 Months">5 Months</option>
              <option value="6 Months">6 Months</option>
              <option value="6+ Months">6+ Months</option>
            </select>
          </div>

          <div className="form-group">
            <label>Job, Attachment or intership location</label>
            <select
              name="location"
              value={formData.location}
              onChange={handleChange}
            >
              <option value="">
                Select county
              </option>
              <option value="Baringo">Baringo</option>
              <option value="Bomet">Bomet</option>
              <option value="Bungoma">Bungoma</option>
              <option value="Busia">Busia</option>
              <option value="Elgeyo-Marakwet">Elgeyo-Marakwet</option>
              <option value="Embu">Embu</option>
              <option value="Garissa">Garissa</option>
              <option value="Homa Bay">Homa Bay</option>
              <option value="Isiolo">Isiolo</option>
              <option value="Kajiado">Kajiado</option>
              <option value="Kakamega">Kakamega</option>
              <option value="Kericho">Kericho</option>
              <option value="Kiambu">Kiambu</option>
              <option value="Kilifi">Kilifi</option>
              <option value="Kirinyaga">Kirinyaga</option>
              <option value="Kisii">Kisii</option>
              <option value="Kisumu">Kisumu</option>
              <option value="Kitui">Kitui</option>
              <option value="Kwale">Kwale</option>
              <option value="Laikipia">Laikipia</option>
              <option value="Lamu">Lamu</option>
              <option value="Machakos">Machakos</option>
              <option value="Makueni">Makueni</option>
              <option value="Mandera">Mandera</option>
              <option value="Marsabit">Marsabit</option>
              <option value="Meru">Meru</option>
              <option value="Migori">Migori</option>
              <option value="Mombasa">Mombasa</option>
              <option value="Murang'a">Murang'a</option>
              <option value="Nairobi">Nairobi</option>
              <option value="Nakuru">Nakuru</option>
              <option value="Nandi">Nandi</option>
              <option value="Narok">Narok</option>
              <option value="Nyamira">Nyamira</option>
              <option value="Nyandarua">Nyandarua</option>
              <option value="Nyeri">Nyeri</option>
              <option value="Samburu">Samburu</option>
              <option value="Siaya">Siaya</option>
              <option value="Taita-Taveta">Taita-Taveta</option>
              <option value="Tana River">Tana River</option>
              <option value="Tharaka-Nithi">Tharaka-Nithi</option>
              <option value="Trans Nzoia">Trans Nzoia</option>
              <option value="Turkana">Turkana</option>
              <option value="Uasin Gishu">Uasin Gishu</option>
              <option value="Vihiga">Vihiga</option>
              <option value="Wajir">Wajir</option>
              <option value="West Pokot">West Pokot</option>
            </select>
          </div>

          <div className="opportunity-form-actions">
            <button
              type="button"
              className="cancel-opportunity-button"
              onClick={onClose}
            >
              Cancel
            </button>

            <button
              type="submit"
              className="submit-opportunity-button"
              disabled={submitting}
            >
              {submitting
                ? "Posting..."
                : "Post opportunity"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default PostOpportunityModal;